<div class="goal-bar-holder" [style.width.%]="100">
  <div class="time-progress-holder">
    <div class="pointer-label" *ngIf="planningSession.timePassedPercentage > 0 && planningSession.timePassedPercentage < 95" [style.left.%]="planningSession.timePassedPercentage">
      {{ "today_cap" | localize }}
    </div>
    <div class="time-progress">
      <div class="pointer" [style.left.%]="planningSession.timePassedPercentage"></div>
    </div>
  </div>
  <div class="goal-bar" [style.width.%]="100">
    <div class="goal-bar-progress" *ngIf="coloringStrategy === 'colors' || coloringStrategy === 'both'" [style.width.%]="goal.attainment * 100" [style.background-color]="goal.color"></div>
    <div class="goal-bar-progress" *ngIf="coloringStrategy !== 'colors' && coloringStrategy !== 'both'" [style.width.%]="goal.attainment * 100" [style.background]="'#2e4354'"></div>
  </div>
</div>
